<template>
  <default-model v-show="visible" :title="title" :confirmText="confirmText" @confirmFn="confirmFn" @closeFn="closeFn">
    <div class="modal-body ">
      <Form :label-width="90">
        <FormItem label="已选择:">
          <span class="fw"> {{selectVal.length}}条任务</span>

        </FormItem>
        <FormItem label="">
          <span class="f14" :class="[openType ==1?'mainCol':'errorCol']"> 确定{{title}}吗？</span>
        </FormItem>
      </Form>
    </div>
  </default-model>
</template>
<script>
import DefaultModel from './defaultModel.vue'
import {batchSwitch, batchDel} from '@/requests/task'
export default {
  props: ['selectVal'],
  data() {
    return {
      title: '批量开启',
      confirmText: '确定',
      visible: false,
      openType: 1
    }
  },
  components: {
    DefaultModel
  },
  watch: {
    openType() {
      if (this.openType == 1) {
        this.title = '批量开启'
      } else if (this.openType == 2) {
        this.title = '批量删除'
      } else {
        this.title = '批量停用'
      }
    }
  },
  methods: {
    confirmFn() {
      if (this.openType == 2) {
        this.batchDel()
      } else {
        this.batchSwitch()
      }
    },
    async batchDel() {
      let ids = []
      this.selectVal.forEach(element => {
        ids.push(element.id)
      });
      let res = await batchDel({
        ids: ids
      })
      if (res.code == 200) {
        this.visible = false
        this.$emit('reshFn')
        this.$Message.success(`${this.title}成功`)
      } else {
        this.$Message.error(res.msg);
      }
    },
    async batchSwitch() {
      let ids = []
      this.selectVal.forEach(element => {
        ids.push(element.id)
      });
      let res = await batchSwitch({
        status: this.openType,
        ids: ids
      })
      if (res.code == 200) {
        this.visible = false
        this.$emit('reshFn')
        this.$Message.success(`${this.title}成功`)
      } else {
        this.$Message.error(res.msg);
      }
    },
    closeFn() {
      this.visible = false
    },
  }
}
</script>
